import { Component, Input, Output, EventEmitter, } from '@angular/core';
export class CfCoreGalleryArrowsComponent {
     prevDisabled: boolean;
     nextDisabled: boolean;

     onPrevClick = new EventEmitter();
     onNextClick = new EventEmitter();
/**
 * @return {?}
 */
handlePrevClick(): void {
        this.onPrevClick.emit();
    }
/**
 * @return {?}
 */
handleNextClick(): void {
        this.onNextClick.emit();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'cf-core-gallery-arrows',
    template: "<div class=\"cf-core-gallery-arrow-wrapper cf-core-gallery-arrow-left\"> <i class=\"fa fa-arrow-circle-left\" aria-hidden=\"true\" (click)=\"handlePrevClick()\" [class.cf-core-gallery-disabled]=\"prevDisabled\"></i> </div> <div class=\"cf-core-gallery-arrow-wrapper cf-core-gallery-arrow-right\"> <i class=\"fa fa-arrow-circle-right\" aria-hidden=\"true\" (click)=\"handleNextClick()\" [class.cf-core-gallery-disabled]=\"nextDisabled\"></i> </div> ",
    styles: [".cf-core-gallery-arrow-wrapper { position: absolute; height: 100%; width: 1px; display: table; z-index: 2000; table-layout: fixed; } .cf-core-gallery-arrow-wrapper.cf-core-gallery-arrow-left { left: 0px; } .cf-core-gallery-arrow-wrapper.cf-core-gallery-arrow-right { right: 0px; } .fa.fa-arrow-circle-left, .fa.fa-arrow-circle-right { top: 50%; transform: translateY(-50%); cursor: pointer; } .fa.fa-arrow-circle-left.cf-core-gallery-disabled, .fa.fa-arrow-circle-right.cf-core-gallery-disabled { opacity: 0.6; cursor: default; } .fa.fa-arrow-circle-left { left: 10px; } .fa.fa-arrow-circle-right { right: 10px; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prevDisabled': [{ type: Input },],
'nextDisabled': [{ type: Input },],
'onPrevClick': [{ type: Output },],
'onNextClick': [{ type: Output },],
};
}

function CfCoreGalleryArrowsComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryArrowsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreGalleryArrowsComponent.ctorParameters;
/** @type {?} */
CfCoreGalleryArrowsComponent.propDecorators;
/** @type {?} */
CfCoreGalleryArrowsComponent.prototype.prevDisabled;
/** @type {?} */
CfCoreGalleryArrowsComponent.prototype.nextDisabled;
/** @type {?} */
CfCoreGalleryArrowsComponent.prototype.onPrevClick;
/** @type {?} */
CfCoreGalleryArrowsComponent.prototype.onNextClick;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
